import { render } from "./assignTest.vue?vue&type=template&id=35d5fb12&scoped=true"
import script from "./assignTest.js?vue&type=script&lang=js"
export * from "./assignTest.js?vue&type=script&lang=js"

import "./assignTest.vue?vue&type=style&index=0&id=35d5fb12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d5fb12"]])

export default __exports__